import "./VerticalNavbar.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";
import { Suspense, useEffect, useRef, useState } from "react";
import { qilloIconMap } from "../../utils/iconMapping.js";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { SlArrowDown } from "react-icons/sl";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import newRequest from "../../utils/newRequest.js";
import { IoCloseSharp } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toCamelCase } from "../../utils/genericFunctions.js";
import { MdHome } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";

const VerticalNavbar = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState({ menu_function: "mainHome", _id: "home_menu_id" });
  const [userRoles, setUserRoles] = useState(null);
  const [uniqueGroupMenus, setUniqueGroupMenus] = useState(null);
  const isFirstRender = useRef(true);
  const searchFieldRef = useRef(null);
  // console.log(`currentUser ${JSON.stringify(currentUser, null, 2)}`);


  const fetchUserRoles = async (userDocid) => {
    try {
      const res = await newRequest.get(`/adUserRole/userRoles/${userDocid}`);
      // console.log(`1 roles ${JSON.stringify(res.data.roles, null, 2)}`);
      if (res.data) {
        setUserRoles(res.data.roles);
        // Check if there is a saved selectedMenu in sessionStorage
        const savedSelectedMenu = JSON.parse(sessionStorage.getItem("selectedMenu"));
        // console.log(`1 savedSelectedMenu ${JSON.stringify(savedSelectedMenu, null, 2)}`);

        if (!savedSelectedMenu) {
          // console.log(`Set default selected menu if sessionStorage is empty`);
          // Set default selected menu if sessionStorage is empty
          setSelectedMenu({
            menu_function: "mainHome",
            _id: "home_menu_id",
          });
        } else {
          // console.log(`2 savedSelectedMenu ${JSON.stringify(savedSelectedMenu, null, 2)}`);
          setSelectedMenu(savedSelectedMenu);
        }
        // Expand the first accordion when component mounts
        if (res.data.roles.length > 0) {
          setExpandedAccordion(res.data.roles[0]._id);
        }
        setUniqueGroupMenus(res.data.unique_group_menus);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };


  const filterGroupMenus = (groupMenus) =>
    groupMenus.filter((singleMenu) =>
      singleMenu?.menu_name?.toLowerCase().includes(searchTerm?.toLowerCase())
    );

  const hasSearchResults = (groupMenus) =>
    filterGroupMenus(groupMenus).length > 0;

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    const newExpanded = isExpanded ? panel : false;
    setExpandedAccordion(newExpanded);
    sessionStorage.setItem("expandedAccordion", newExpanded);
  };

  useEffect(() => {
    // Fetch roles and set user menus
    fetchUserRoles(currentUser?._id);
    // Retrieve stored values from sessionStorage for expandedAccordion, menuExpanded, and selectedMenu
    const savedExpandedAccordion = sessionStorage.getItem("expandedAccordion");
    if (savedExpandedAccordion) {
      setExpandedAccordion(savedExpandedAccordion);
    }
  }, [currentUser]);


  useEffect(() => {
    // Save selectedMenu to sessionStorage whenever it changes
    if (selectedMenu) {
      sessionStorage.setItem("selectedMenu", JSON.stringify(selectedMenu));
    }
  }, [selectedMenu]);

  useEffect(() => {
    // Save expandedAccordion to sessionStorage whenever it changes
    if (expandedAccordion) {
      sessionStorage.setItem("expandedAccordion", expandedAccordion);
    }
  }, [expandedAccordion]);


  const filteredGroupMenus = uniqueGroupMenus?.filter(
    (item) =>
      item.menu_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleMenuNavigate = async (actualMenu) => {
    try {
      // console.log(`handleMenuNavigate ${JSON.stringify(actualMenu, null, 2)}`);
      if (actualMenu) {
        setSelectedMenu(prev => { return actualMenu; });
        if (actualMenu?._id === "home_menu_id") {
          navigate("/", {
            replace: true,
            state: {
              menuDocid: actualMenu?._id,
              favMenu: actualMenu?.favourite_xx,
              menuFilter: actualMenu?.menu_filter,
            }
          });
        } else if (actualMenu?._id === "config") {
          navigate("/config", {
            replace: true,
            state: {
              menuDocid: actualMenu?._id,
              favMenu: actualMenu?.favourite_xx,
              menuFilter: "none",
            }
          });
        } else {
          navigate(`/${actualMenu.menu_function}`, {
            replace: true,
            state: {
              menuDocid: actualMenu?._id,
              favMenu: actualMenu?.favourite_xx,
              menuFilter: actualMenu?.menu_filter,
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <motion.div
      className="vertical-navbar-menu"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="loading-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="vertical-navbar-menu-main-wrapper">
          <div className="vertical-navbar-menu-wrapper">
            <div className="vertical-navbar-menu-navbar">
              <span style={{ overflow: "hidden", borderRadius: "50%" }}>
                {/* {["regulator"].includes(currentUser?.token_org_type) && <img src="/img/sha_logo.svg" alt="" className="craft-icon" />}
                {["agent", "broker", "insurance"].includes(currentUser?.token_org_type) && <h1 className='my-logo-text md'>{t('appNameShort')}</h1>} */}
                <img src="/img/fav.png" alt="" className="craft-icon" />
              </span>
              <HiOutlineMenuAlt3
                className="menu-icon"
                onClick={() => { }}
              />
            </div>
            <div className="vertical-navbar-menu-content">
              <div className="search-input-wrapper"
                style={{ width: "100%", marginBottom: "10px" }} >
                <FiSearch className="search-input-icon" />
                <input
                  ref={searchFieldRef}
                  className="search-input"
                  type="text"
                  placeholder={t('search')}
                  value={searchTerm}
                  onChange={(e) => {
                    try {
                      setSelectedMenu(null);
                      setSearchTerm(e.target.value);
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                />
                {searchTerm.length > 0 && (
                  <IoCloseSharp
                    onClick={() => {
                      setSearchTerm("");
                      if (searchFieldRef.current) {
                        searchFieldRef.current?.focus();
                      }
                    }}
                    className="search-input-icon"
                  />
                )}
              </div>
              <div className="home-button" >
                <span className={`${selectedMenu?._id === "home_menu_id"
                  ? "home-action-button active"
                  : "home-action-button"
                  }`}
                  onClick={() => handleMenuNavigate({ menu_function: "mainHome", _id: "home_menu_id" })}>
                  <MdHome size={24} className="menu-icon" /> {t('home')}
                </span>
              </div>
              {currentUser?.usr_org_code === "000" &&
                <div className="home-button">
                  <span className={`${selectedMenu?._id === "config"
                    ? "home-action-button active"
                    : "home-action-button"
                    }`}
                    onClick={() => handleMenuNavigate({ menu_function: "config", _id: "config" })}>
                    <IoMdSettings size={24} className="menu-icon" /> {t('config')}
                  </span>
                </div>}
              {/* <span style={{ display: "block", width: "95%", height: "0.5px", backgroundColor: "#ccc" }} /> */}
              {/* when there's a search term and menu expanded*/}
              {searchTerm?.length > 0 && (
                <div className="searched-menu">
                  {filteredGroupMenus?.length > 0 &&
                    <div className="single-menus-wrapper">
                      {filteredGroupMenus?.map((singleMenu, index) => {
                        // console.log(`Current singleMenu _id: ${singleMenu._id}, selectedMenu _id: ${selectedMenu?._id}`);
                        const IconComponent = qilloIconMap[singleMenu?.menu_icon];

                        return (
                          <div
                            className={`${selectedMenu?._id ===
                              singleMenu._id
                              ? "single-menu active"
                              : "single-menu"
                              }`}
                            key={`${singleMenu?._id}-${index}`}
                            onClick={() => handleMenuNavigate(singleMenu)}
                          >
                            <>
                              <Suspense fallback={<span>Loading...</span>}>
                                <IconComponent className="menu-icon" />
                              </Suspense>
                              <span className="menu-name">{t(toCamelCase(singleMenu?.menu_name || "Menu"))}</span>
                            </>
                          </div>
                        );
                      })}
                    </div>}
                </div>
              )}

              {/* <span>{selectedMenu?._id}</span> */}
              {/* When Main Menu is expanded and User has roles and no search term has been defined */}
              {userRoles?.length > 0 && searchTerm.length === 0 && (
                <div className="main-menu">
                  {userRoles?.map((role, index) => (
                    <div className="roles-wrapper" key={`${role?._id}-${index}`}>
                      <Accordion
                        className="accordion"
                        expanded={
                          expandedAccordion === role._id ||
                          (searchTerm && hasSearchResults(role.role_menus_xx))
                        }
                        onChange={handleAccordionChange(role._id)}
                      >
                        <AccordionSummary
                          expandIcon={
                            <SlArrowDown
                              className="content-accordion-expand-icon"
                              style={{ color: "#f44336", fontWeight: "bold" }}
                            />
                          }
                          id={`panel-header-${role._id}`}
                        >
                          <Typography className="role-name">
                            {t(toCamelCase(role.role_name_xx))}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="role-group-menus">
                            {role?.role_menus_xx?.map((gmenu, index) => {
                              // const filteredMenus = filterGroupMenus(
                              //   gmenu.group_menus
                              // );
                              return (
                                <div key={`${gmenu?._id}-${index}`}>
                                  <span className="menu_group_name">
                                    {t(toCamelCase(gmenu?.menu_group_name))}
                                  </span>
                                  {gmenu?.group_menus?.length > 0 && (
                                    <div className="single-menus-wrapper">
                                      {gmenu?.group_menus?.map((singleMenu, index) => {
                                        const IconComponent =
                                          qilloIconMap[singleMenu?.menu_icon];
                                        return (
                                          <div
                                            className={`${selectedMenu?._id ===
                                              singleMenu?._id
                                              ? "single-menu active"
                                              : "single-menu"
                                              }`}
                                            key={`${singleMenu?._id}-${index}`}
                                            onClick={() => handleMenuNavigate(singleMenu)}
                                          >
                                            <>
                                              <Suspense fallback={<span>Loading...</span>}>
                                                <IconComponent className="menu-icon" />
                                              </Suspense>
                                              <span className="menu-name">{t(toCamelCase(singleMenu?.menu_name || "Menu"))}</span>
                                            </>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default VerticalNavbar;